const KEY = 'momentum.save.v1';

/**
 * Progress + records. Deliberately tiny and forward compatible: unknown level
 * ids simply appear as new records, so adding levels never invalidates a save.
 */
export class Save {
  constructor() {
    this.data = { cleared: {}, best: {}, ghosts: {}, topSpeed: 0, maxDrop: 0, runs: 0 };
    this.load();
  }

  load() {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) Object.assign(this.data, JSON.parse(raw));
    } catch (e) {
      console.warn('[save] load failed', e);
    }
  }

  persist() {
    try { localStorage.setItem(KEY, JSON.stringify(this.data)); }
    catch (e) { console.warn('[save] write failed', e); }
  }

  isCleared(id) { return !!this.data.cleared[id]; }
  ghost(id) { return this.data.ghosts?.[id] ?? null; }
  setGhost(id, track) {
    if (!this.data.ghosts) this.data.ghosts = {};
    this.data.ghosts[id] = track;
    this.persist();
  }

  bestTime(id) { return this.data.best[id] ?? null; }

  /** @returns {boolean} true when this run set a new record for the level */
  recordRun(id, timeSec, stats = {}) {
    this.data.runs++;
    this.data.cleared[id] = true;
    const prev = this.data.best[id];
    const isRecord = prev == null || timeSec < prev;
    if (isRecord) this.data.best[id] = timeSec;
    if (stats.topSpeed > this.data.topSpeed) this.data.topSpeed = stats.topSpeed;
    if (stats.maxDrop > this.data.maxDrop) this.data.maxDrop = stats.maxDrop;
    this.persist();
    return isRecord;
  }

  wipe() {
    this.data = { cleared: {}, best: {}, ghosts: {}, topSpeed: 0, maxDrop: 0, runs: 0 };
    this.persist();
  }
}
